module.exports = __webpack_public_path__ + "img/builder-16.27d73f54.jpg";